import { Button } from "@altek/ui/components/ui/Button";
import { Banner } from "@altek/ui/components/feedback/Banner";
import { useRealtimeConnection } from "./useRealtime";

/**
 * «Canlı bağlantı yok» — the one place in the shell that says the stream is away.
 *
 * WHY IT IS QUIET. A reconnect normally takes a second or two and the person never needs to know:
 * announcing every hiccup is how an indicator becomes something people stop reading. So nothing is
 * drawn until the stream has been away for `DISCONNECTED_GRACE_MS`, and nothing at all while
 * another tab of this browser holds it (`follower` — the frames still arrive).
 *
 * WHY IT IS SAID AT ALL. Without it, a dead stream looks exactly like a quiet afternoon: the rail
 * stops moving, the badge stops counting, and the person keeps working on a screen that is
 * silently out of date. The honest thing is to say the screen may be stale and offer the one
 * action that fixes it.
 *
 * IN THE SHELL, not on every screen. Chat says the same thing in its own dock subtitle, where a
 * person who is in the middle of a conversation is actually looking.
 */
export function RealtimeIndicator() {
  const { degraded, status, reconnect } = useRealtimeConnection();
  if (!degraded) return null;

  const stopped = status === "stopped";
  return (
    <Banner
      tone="warning"
      title="Canlı bağlantı yok"
      action={
        <Button size="sm" variant="secondary" onClick={reconnect}>
          Yeniden bağlan
        </Button>
      }
    >
      {stopped
        ? "Yeni mesajlar ve bildirimler kendiliğinden gelmiyor. Yeniden bağlanın ya da sayfayı yenileyin."
        : "Bağlantı yeniden kuruluyor. Bu sürede ekrandaki bilgiler güncellenmeyebilir."}
    </Banner>
  );
}
